import React from 'react';
import Price from 'atomic/price';

interface ProductBoxPriceProps {
    price: number;
    offersCount: number;
    discount: number;
    prevPrice?: number;
    showPrefix?: boolean;
}

const ProductBoxPrice: React.FC<ProductBoxPriceProps> = ({
    price,
    prevPrice = 0,
    offersCount,
    discount,
    showPrefix = true
}) => {
    return (
        <>
            { offersCount > 0
                ? (
                    <>
                        {price && showPrefix ? 'od ' : ''}
                        <Price price={price} color="secondary" />
                        {(discount > 0 && offersCount > 0) && (
                            <Price
                                className="discount"
                                price={prevPrice}
                                crossed={true}
                                color="red"
                                weight={500}
                                fontSize={12}
                            />
                        )}
                    </>
                )
                : (
                    <>
                        {price ? 'ostatnia znana cena ' : ''}
                        {price ? <Price price={price} color="secondary" /> : ''}
                    </>
                )
            }
        </>
    );
};

export default ProductBoxPrice;
